type InputType = 'users' | 'sites';

export const InputTypes = {
  user: 'users' as InputType,
  site: 'sites' as InputType,
};
